var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-lang',{staticClass:"account-language-select",on:{"change:language":_vm.change_language}})}
var staticRenderFns = []

export { render, staticRenderFns }